__turbopack_context__.v({
  "mobileSectionContainer": "RecommendedSection-module-scss-module__qubU-a__mobileSectionContainer",
  "sectionContainer": "RecommendedSection-module-scss-module__qubU-a__sectionContainer",
});
